export interface SoftwareOverviewLicense {
  id: string;
  reference: string;
  product: string;
  status: string;
  isPerpetual: boolean;
  expiresAt?: string | null;
  company: { name: string };
}

// Commercial expiry is a calendar date, independent of the browser timezone.
export const softwareExpiryDays = (license: SoftwareOverviewLicense, now = Date.now()) => {
  if (license.isPerpetual || !license.expiresAt) return null;
  const end = Date.parse(`${license.expiresAt.slice(0, 10)}T23:59:59.999Z`);
  return Number.isFinite(end) ? Math.ceil((end - now) / 86400000) : null;
};

export const summarizeSoftwareLicenses = (licenses: SoftwareOverviewLicense[], now = Date.now()) => {
  const soon = licenses.filter(l => {
    const days = softwareExpiryDays(l, now);
    return l.status === 'ACTIVE' && days !== null && days >= 0 && days <= 30;
  });
  const blocked = licenses.filter(l => ['EXPIRED', 'SUSPENDED'].includes(l.status));
  return {
    total: licenses.length,
    active: licenses.filter(l => l.status === 'ACTIVE').length,
    soon: soon.length,
    blocked: blocked.length,
    attention: [...blocked, ...soon].sort((a, b) =>
      Number(b.status !== 'ACTIVE') - Number(a.status !== 'ACTIVE') ||
      (softwareExpiryDays(a, now) ?? Infinity) - (softwareExpiryDays(b, now) ?? Infinity) ||
      a.company.name.localeCompare(b.company.name, 'it')),
  };
};
